<script>
  import { onMount } from 'svelte';


  import Audio from './Audio.svelte';
  import Gallery from './Gallery.svelte';
  import Rollscanmodal from './Rollscanmodal.svelte';
  import Movie from './Movie.svelte';
  import Downloads from './Downloads.svelte';
  import Section from './Section.svelte';
  import Loader from './Loader.svelte';
  import PreviewImage from './PreviewImage.svelte';

  import l from "../scripts/utilities.js";
  const app = document.querySelector("#app");

  const url = app.getAttribute("data-singleview-url");

  let backlink = app.getAttribute("data-overview-url") ? app.getAttribute("data-overview-url") : "#";
  let backlinktext = app.getAttribute("data-overview-linktext") ? app.getAttribute("data-overview-linktext") : "zurück";

  async function getData(u) {
		const res = await fetch(u);
		const json = await res.json();

		if (res.ok) {
			return json;
		} else {
			throw new Error(json);
		}
	}

  let promise = getData(url)
  onMount(async() => {
    refreshFsLightbox();
  });
  function close() {
    document.location.href = backlink;
  }
</script>
{#await promise}
  <Loader message="{l('loading')}" />
{:then detail}

<div class='detail-window'>
<div class="detail-header">
  <span class="roll-id">{detail.roll_id.c}</span> <span class="close"><button onclick={close}><span class="label">{backlinktext}</span> </button></span>
</div>

<div class="detail-content">
  <span class="sup-title h-regular">{detail.composer.c}</span>
  <h1 class="h-bold"><span class="h-underline">{detail.title}</span></h1>

  <PreviewImage item={detail} />

  <div class="gallery">
    <span class="section-title">{l("gallery_title")}</span>
    {#if detail.gallery.audio}
      <Audio audio={detail} />
    {/if}
    {#if detail.gallery.rollscan}
      <Rollscanmodal item={detail} />
    {/if}
    {#if detail.gallery.images.length}
      <Gallery item={detail} />
    {/if}
    {#if detail.gallery.youtube}
      <Movie item={detail} />
    {/if}
  </div>



  <Section cssClass="gnd-data" items={detail.gnd_data} />
  <Section cssClass="tpl-data" items={detail.tpl_data} />
  <Section cssClass="details" items={detail.details} />

  <Downloads item={detail} title={l("download_title")} />

  {#if detail.additionals.c != ''}
  <div class="more">
    <span class="section-title">{detail.additionals.t}</span>
    <div class="content">{@html detail.additionals.c}</div>
  </div>
  {/if}
</div>
</div>
{:catch error}
  could not load data {error.message}
{/await}